// extracted by mini-css-extract-plugin
module.exports = {"button":"PaymentAccessTable_button__6fCWz"};